import { authenticate } from '@/calls/profile';
import router from '@/router';

const login = {
  namespaced: true,
  state: {
    requests: 0,
    logged: false,
    error: false,
    redirectTo: '/profile',
    fields: {
      email: '',
      key: ''
      // key: ORD03157189
    }
  },
  mutations: {
    updateField(state, { type, value }) {
      state.fields[type] = value;
    },
    updateRedirect(state, route) {
      state.redirectTo = route;
    },
    setLogged(state, flag) {
      state.logged = flag;
    },
    setError(state, flag) {
      state.error = flag;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    async authenticate({ state, commit, dispatch }) {
      commit('increaseRequests');
      commit('setError', false);

      const request = await authenticate({
        email: state.fields.email,
        orderreference: state.fields.key
      });

      if (request.success) {
        if (request.data.length > 0) {
          const infos = request.data[0];
          commit('profile/updateInfos', infos, { root: true });
          dispatch('profile/checkUserPref', null, { root: true });
          commit('setLogged', true);
          router.push(state.redirectTo);
        } else {
          // No account found
          commit('setError', true);
        }
      }

      commit('decreaseRequests');
    },
    async logout({ commit, dispatch }) {
      commit('setLogged', false);
      dispatch('profile/logout', null, { root: true });
      commit('updateField', {
        type: 'email',
        value: ''
      });
      commit('updateField', {
        type: 'key',
        value: ''
      });
      router.push('/');
    }
  }
};

export default login;
